import { render, staticRenderFns } from "./SwiperItem.vue?vue&type=template&id=d59b963c&scoped=true"
import script from "./SwiperItem.vue?vue&type=script&lang=js"
export * from "./SwiperItem.vue?vue&type=script&lang=js"
import style0 from "./SwiperItem.vue?vue&type=style&index=0&id=d59b963c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59b963c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d59b963c')) {
      api.createRecord('d59b963c', component.options)
    } else {
      api.reload('d59b963c', component.options)
    }
    module.hot.accept("./SwiperItem.vue?vue&type=template&id=d59b963c&scoped=true", function () {
      api.rerender('d59b963c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiper/SwiperItem.vue"
export default component.exports